<div class="container my-auto">
  @if (!error) {
    <div class="row card-container my-4">
      <div class="col-12 col-sm-6 signup-container">
        <h2 translate>SIGNUP.TITLE_FORM</h2>
        @if (!campaignToken) {
          <!-- Normal signup: user has to fill more mandatory fields, thus we also need a stepper -->
          <app-signup-form-default (submitSignup)="signup($event)">
            <!-- pass the tac-block -->
            <ng-template [ngTemplateOutlet]="tac"></ng-template>
          </app-signup-form-default>
        } @else {
          <!-- Campaign signup: user has to fill only 4 mandatory fields, no stepper needed -->
          <app-signup-form-campaign (submitSignup)="signup($event)">
            <!-- pass the tac-block -->
            <ng-template [ngTemplateOutlet]="tac"></ng-template>
          </app-signup-form-campaign>
        }
      </div>
      <div class="col-12 col-sm-6 benefits-container">
        <h1>{{ (content$ | async)?.headline }}</h1>
        <div class="benefits">
          @for (benefit of (content$ | async)?.benefits; track benefit) {
            <div class="mt-4 benefit">
              <mat-icon svgIcon="check_v2"></mat-icon>
              <span class="ms-2">{{benefit}}</span>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <!-- Error is shown if BE returns an error after signup saying that the campaign-key is invalid -->
  @if (error && !!errorType) {
    <div class="row card-container error-container my-4 mx-auto">
      <div class="col-12 signup-container">
        <p class="error">
          <span translate>SIGNUP.ERROR.{{errorType.toUpperCase()}}_PRE</span>
          <a href="mailto:info@troodi.de">info&#64;troodi.de</a>
          <span translate>SIGNUP.ERROR.{{errorType.toUpperCase()}}_POST</span>
        </p>
        <button (click)="resetCampaignData()" class="mt-3 w-auto" mat-raised-button color="primary">
          <span translate>SIGNUP.ERROR_BUTTON</span>
        </button>
      </div>
    </div>
  }
</div>
<!-- this is the 'Accept Terms and Conditions'-block as a template for re-usage -->
<ng-template #tac>
  <div class="mt-4 text-center accept-terms">
    <span translate>SIGNUP.ACCEPT_TERMS_PRE</span>
    <a class="textlink" target="_blank" rel="noopener noreferrer" href="https://troodi.de/impressum/#ds">
      <span translate>SIGNUP.TERMS</span>
    </a>
    <span translate>SIGNUP.ACCEPT_TERMS_POST</span>
  </div>
</ng-template>
